<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="dialogTitle" width="800" draggable>
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" class="userFrom">
                    <el-form-item :label="t('personnelDialog.captain')" prop="d_id">
                        <el-select :placeholder="t('personnelDialog.selectRequired')" v-model="state.form.d_id" filterable>
                            <el-option v-for="(d, i) in state.captainList" :key="i" :label="d.real_name" :value="d.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="t('personnelDialog.personnel')" prop="user_id">
                        <el-select :placeholder="t('personnelDialog.selectRequired')" v-model="state.form.user_id" filterable multiple>
                            <el-option v-for="(d, i) in state.userList" :key="i" :label="d.real_name" :value="d.id" />
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                <el-button type="primary" @click="submit">{{ t('common.confirm') }}</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive, ref, defineEmits, defineProps, defineExpose, computed } from "vue";
import { ElMessage } from "element-plus";
import { pageListApi as userListApi } from "@/api/system/personnel";
import { bindUserApi } from "@/api/machinist/detail";
import { usePageI18n, t } from "@/composables/usePageI18n.js";

const emit = defineEmits(['refresh']);
const props = defineProps({ title: { type: String, default: '' } });

const dialogTitle = computed(() => props.title || t('personnelDialog.linkMachinist'));
const state = reactive({
    dialogVisible: false,
    captainList: [],
    userList: [],
    form: { d_id: null, user_id: [] },
});

const getUserList = () => {
    userListApi(JSON.stringify({ page: 1, limit: 9999, keywords: "", role_id: 0 })).then(res => {
        state.userList = res.data.filter(i => i.role_id == 1);
        state.captainList = res.data.filter(i => i.role_id == 2);
    });
};

const open = () => {
    state.dialogVisible = true;
    getUserList();
};

const ruleForm = ref(null);
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (!valid) return false;
        bindUserApi(JSON.stringify(state.form)).then(res => {
            if (res?.code === 200) {
                ElMessage.success(t('common.success'));
                state.dialogVisible = false;
                emit('refresh');
            }
        });
    });
};

usePageI18n(() => {});
defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man { padding: 0 30px; }
</style>
